import {
  IDeletePicturesPayload,
  IGetPicturesPayload,
  IPostPicturesPayload,
} from '../api/repositories/picture/picture.types';
import { ActionsUnion, createAction } from '../helpers';
import { IPictureEntries, IPicturesEntries } from './types';

export enum EPicturesActionType {
  GET = 'PICTURES_GET',
  GET_ASYNC = 'PICTURES_GET_ASYNC',
  GET_SUCCESS = 'PICTURES_GET_SUCCESS',
  POST = 'PICTURES_POST',
  POST_SUCCESS = 'PICTURES_POST_SUCCESS',
  SET_MAIN = 'PICTURES/SET_MAIN',
  POST_BY_URI = 'PICTURES_POST_BY_URI',
  DELETE = 'PICTURES_DELETE',
  DELETE_SUCCESS = 'PICTURES_DELETE_SUCCESS',
}

// TO DO: actionCreator for all actions
export const picturesActions = {
  setMainPicture: (pictureId: string) =>
    createAction(EPicturesActionType.SET_MAIN, pictureId),
};

export type IPicturesActionCreator = ActionsUnion<typeof picturesActions>;

// POST
export interface IPostPicturesAction {
  type: EPicturesActionType.POST;
  payload: IPostPicturesPayload;
}

export const postPicturesAction = (
  payload: IPostPicturesPayload
): IPostPicturesAction => ({
  type: EPicturesActionType.POST,
  payload,
});

export interface IPostPictureByUriAction {
  type: EPicturesActionType.POST_BY_URI;
  payload: { uri: string };
}

export const postPictureByUriAction = (
  uri: string
): IPostPictureByUriAction => ({
  type: EPicturesActionType.POST_BY_URI,
  payload: { uri },
});

export interface IPostPicturesSuccessAction {
  type: EPicturesActionType.POST_SUCCESS;
  payload: IPictureEntries;
}

export const postPicturesSuccessAction = (picture: IPictureEntries) => ({
  type: EPicturesActionType.POST_SUCCESS,
  payload: picture,
});

// GET
export interface IGetPicturesAction {
  type: EPicturesActionType.GET;
  payload: IGetPicturesPayload;
}

export const getPicturesAction = (accountId: string): IGetPicturesAction => ({
  type: EPicturesActionType.GET,
  payload: { id: accountId },
});

// GET ASYNC
export interface IGetPicturesAsyncAction {
  type: EPicturesActionType.GET_ASYNC;
  payload: IGetPicturesPayload;
}

export const getPicturesAsyncAction = (
  accountId: string
): IGetPicturesAsyncAction => ({
  type: EPicturesActionType.GET_ASYNC,
  payload: { id: accountId },
});

export interface IGetPicturesSuccessAction {
  type: EPicturesActionType.GET_SUCCESS;
  payload: IPicturesEntries;
}

export const getPicturesSuccessAction = (
  pictures: IPicturesEntries
): IGetPicturesSuccessAction => ({
  type: EPicturesActionType.GET_SUCCESS,
  payload: pictures,
});

// DELETE
export interface IDeletePictureAction {
  type: EPicturesActionType.DELETE;
  payload: IDeletePicturesPayload;
}

export const deletePictureAction = (
  pictureId: string
): IDeletePictureAction => ({
  type: EPicturesActionType.DELETE,
  payload: { id: pictureId },
});

export interface IDeletePictureSuccessAction {
  type: EPicturesActionType.DELETE_SUCCESS;
  payload: IDeletePicturesPayload;
}

export const deletePictureSuccessAction = (
  pictureId: string
): IDeletePictureSuccessAction => ({
  type: EPicturesActionType.DELETE_SUCCESS,
  payload: { id: pictureId },
});

export type IPicturesAction =
  | IPostPicturesAction
  | IPostPicturesSuccessAction
  | IGetPicturesAction
  | IGetPicturesSuccessAction
  | IDeletePictureAction
  | IDeletePictureSuccessAction;
